import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { VariantPropTypes } from './VariantComponent';
import { VariantComponentStyled } from './variantsStyles';


/**
 * Determines if a given variant should use the dropdown display form
 * given the overall props/state.
 * @param {VariantPropTypes} variant
 * @param {VariantsComponent.propTypes} props
 * @returns {boolean}
 */
const shouldUseDropdown = (variant, props) => {
	if (props.variants && props.variants.length > 4) {
		if (variant.values.length > 4) {
			// If there are more than 4 variants, then use the dropdown when there are more than 4 options
			return true;
		}
	} else {
		if (variant.values.length > 4) {
			// If there is only 1 variant, but it has more than 4 options use dropdown
			return true;
		}
	}
	return false;
};

export const VariantsComponent = (props) => {
	return (
		<Fragment>
			{props.variants && props.variants.map((variant, idx) => (
				<VariantComponentStyled
					key={`variant-${idx}`}
					id={`variant-${idx}`}
					variant={variant}
					value={props.variantValues[idx] || ''}
					onValueChange={props.onVariantChange(idx)}
					useDropdown={shouldUseDropdown(variant, props)}
				/>
			))}
		</Fragment>
	);
};

VariantsComponent.propTypes = {
	variants: PropTypes.arrayOf(VariantPropTypes),
	variantValues: PropTypes.array,
	onVariantChange: PropTypes.func,
};
